export function createCMMSView({ data = null, error = null }) {
  return { data, error };
}
